<template>
  <!--
    	作者：zct
    	时间：2021-10-08
    	描述：队伍-编辑队伍
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--编辑队伍-->
      <div class="common-form">编辑队伍</div>
      <el-form-item label="队伍名称" prop="unit_group_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.unit_group_name" placeholder="请输入队伍名称" class="max-w460"></el-input>
      </el-form-item>
      <!-- <el-form-item label="队伍logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="file_path!=''" class="img">
            <img :src="file_path" width="100" />
          </div>
        </el-row>
      </el-form-item> -->
      <el-form-item label="队长ID" >
         <el-input type="text" v-model="form.group_user_id" autocomplete="off" style="width:180px"  readonly="">
         <el-button slot="append" type="primary" icon="el-icon-user-solid" @click="openUserDialog()">选择用户</el-button>
         </el-input>

       </el-form-item>
      <el-form-item label="队长名称" >
         <el-input type="text" v-model="real_name" autocomplete="off" style="width:180px"  readonly="">

         </el-input>

       </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <!--用户选择-->
    <GetUser :is_open="open_user" :form='form' @close="closeUserDialog"></GetUser>
  </div>
</template>

<script>

  import unitApi from '@/api/unit.js';
  import Upload from '@/components/file/Upload';
  import GetUser from '@/components/user/GetUnitGroupUser.vue';
  import { formatModel } from '@/utils/base.js'
  export default {
    components: {
      Upload,
      GetUser
    },
    data() {
      return {
        /*form表单数据*/
        form: {
          unit_id:'',
          unit_group_id:'',
          unit_group_name: '',
          group_user_id:'',


        },
        real_name:'',
        /*是否上传图片*/
        isupload: false,
        loading: false,
        file_path: '',
        open_user:false,

      };
    },
    created() {

      this.form.unit_id =this.$route.query.unit_id;
      this.form.unit_group_id =this.$route.query.unit_group_id;
      this.getData();
    },

    methods: {
      /*修改*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            unitApi.editGroup(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，队伍修改成功',
                  type: 'success'
                });
                self.$router.push({path:'/unit/group/index',query:{unit_id:self.form.unit_id}});
              }).catch(error => {
                self.loading = false;
              });
          }
        });
      },

      /*获取参数*/
      getData() {
        let self = this;
        unitApi.groupDetail({
            unit_group_id: self.form.unit_group_id
          }, true)
          .then(res => {
            self.form = res.data.model;
            if(res.data.model.groupUser){
              self.real_name = res.data.model.groupUser.real_name;
            }
            console.log(self.form)
          })
          .catch(error => {

          });

      },

      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null) {
          this.file_path = e[0].file_path;
          this.form.logo_image_id = e[0].file_id;
        }
        this.isupload = false;
      },

      /*打开用户弹窗*/
      openUserDialog() {

        this.open_user = true;
      },
      /*关闭用户弹窗*/
      closeUserDialog(e) {
        if (e.type != 'error') {
          this.form.group_user_id = e.params[0].user_id;
          this.real_name = e.params[0].real_name;
        }
        this.open_user = false;
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },


    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/unit/group/edit.vue